import type { ComponentPropsWithoutRef } from 'react'
import styled, { css } from 'styled-components'

import { theme } from '@/styles/theme'

import type { NewsTagProps } from '@/components/elements/News/NewsTag'

type Props = {
  tag: NewsTagProps
  isActive: boolean
  size?: 'regular' | 'small'
} & ComponentPropsWithoutRef<'button'>

export const NewsTagButton = ({ tag, isActive, size, ...props }: Props) => {
  const tagColor =
    tag.code === 'importantNotices' ? theme.colors.red : theme.colors.trialBlue

  return (
    <TagButton
      type="button"
      aria-pressed={isActive}
      color={tagColor}
      size={size}
      {...props}
    >
      {tag.name}
    </TagButton>
  )
}

const SmallButton = css`
  font-size: 13px;
  letter-spacing: 0;
  line-height: 23px;
  padding: 0 28px;
  height: 25px;
`

const RegularButton = css`
  font-size: 16px;
  line-height: 27px;
  padding: 0 18px;
  height: 36px;

  @media screen and (max-width: 1047px) {
    height: 34px;
    font-size: 14px;
    line-height: 24px;
  }
`

const TagButton = styled.button<{ color: string; size?: 'regular' | 'small' }>`
  ${({ size }) => (size === 'small' ? SmallButton : RegularButton)};
  border: ${({ color }) => `1px solid ${color}`};
  border-radius: 2px;
  cursor: pointer;
  transition: 0.3s;
  color: ${({ color }) => color};
  background-color: #ffffff;

  &[disabled] {
    cursor: default;
  }

  @media (hover: hover) {
    &:hover {
      opacity: 0.6;
    }
  }

  &[aria-pressed='true'] {
    color: #ffffff;
    background-color: ${({ color }) => color};
  }
`
